(() => {
  if (window.inpulseExperienceLoaded) return;
  window.inpulseExperienceLoaded = true;
  const controllers = new WeakMap();
  function initialize(wrapper) {
    const root = wrapper.querySelector('.ie');
    const configNode = wrapper.querySelector('[data-experience-config]');
    if (!root || !configNode || controllers.has(wrapper)) return;
    const config = JSON.parse(configNode.textContent);
    const controller = new AbortController();
    const options = { signal: controller.signal };
    controllers.set(wrapper, controller);
    const start = root.querySelector('[data-exercise-start]');
    const exercise = root.querySelector('[data-exercise]');
    const next = root.querySelector('[data-exercise-next]');
    const close = root.querySelector('[data-exercise-close]');
    const line = root.querySelector('[data-exercise-line]');
    const count = root.querySelector('[data-step-count]');
    let step = 0;
    const render = () => {
      line.textContent = config.steps[step];
      count.textContent = `Step ${step + 1} of ${config.steps.length}`;
      next.textContent = step === config.steps.length - 1 ? config.restartLabel : config.nextLabel;
    };
    const closeExercise = () => {
      exercise.hidden = true;
      start.setAttribute('aria-expanded', 'false');
      start.focus();
    };
    start.addEventListener('click', () => {
      step = 0;
      render();
      exercise.hidden = false;
      start.setAttribute('aria-expanded', 'true');
      next.focus();
    }, options);
    next.addEventListener('click', () => {
      step = (step + 1) % config.steps.length;
      render();
    }, options);
    close.addEventListener('click', closeExercise, options);
    root.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !exercise.hidden) closeExercise();
    }, options);
    const heading = root.querySelector('[data-reveal-heading]');
    // Cosmetic movement only. Missing observers and editor reloads cannot hide content.
    if (!window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          heading.classList.add('is-visible');
          observer.disconnect();
        }
      }, { threshold: 0 });
      observer.observe(heading);
      controller.signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }
  }
  document.querySelectorAll('.shopify-section').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.get(event.target)?.abort();
    controllers.delete(event.target);
  });
})();
